import Vue from 'vue'

const EVENT_BUS = new Vue()

export default EVENT_BUS
